import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const officeTransAdapter = createEntityAdapter({})
const initialState = officeTransAdapter.getInitialState()

export const officeTransApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getofficeTrans: builder.query({
            query: () => ({
                url: '/officetrans',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedofficeTrans = responseData.map(officeTrans => {
                    officeTrans.id = officeTrans._id
                    return officeTrans
                });
                return officeTransAdapter.setAll(initialState, loadedofficeTrans)
            },
            providesTags: (result, error, arg) => { 
                if (result?.ids) {
                    return [
                        { type: 'officeTrans', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'officeTrans', id }))
                    ]
                } else return [{ type: 'officeTrans', id: 'LIST' }]
            }
        }),
        addNewofficeTrans: builder.mutation({
            query: initialUserData => ({
                url: '/officetrans',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'officeTrans', id: "LIST" }
            ]
        }),
        updateofficeTrans: builder.mutation({
            query: initialUserData => ({
                url: '/officetrans',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'officeTrans', id: arg.id }
            ]
        }), 
        deleteofficeTrans: builder.mutation({
            query: ({ id }) => ({
                url: `/officetrans`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'officeTrans', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetofficeTransQuery,
    useAddNewofficeTransMutation,
    useDeleteofficeTransMutation,
    useUpdateofficeTransMutation
} = officeTransApiSlice

// returns the query result object
export const selectofficeTransResult = officeTransApiSlice.endpoints.getofficeTrans.select()

// creates memoized selector
const selectofficeTransData = createSelector(
    selectofficeTransResult,
    officeTransResult => officeTransResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllofficeTrans,
    selectById: selectofficeTransById,
    selectIds: selectofficeTransIds
    // Pass in a selector that returns the users slice of state
} = officeTransAdapter.getSelectors(state => selectofficeTransData(state) ?? initialState)